import React, { ReactNode, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Notifications from '@ordermentum/ui-shared/organisms/Notifications';
import { hideNotification, removeNotification } from '@ordermentum/ui-toast';
import PageLoader from '@ordermentum/ui-shared/molecules/PageLoader';
import { fetchFlagsAsync } from '@ordermentum/ui-shared/redux/flags';
import { UINotification } from '@ordermentum/ui-definitions';
import { fetchProfileDetailsAsync } from '../../redux/actions';
import { RootState } from '../../redux/store';

export const SUPPLIER_ASYNC_PAYMENTS = 'supplier-async-payments';

const flags = ['google-login'];

const initApp = () => async dispatch => {
  const user = await dispatch(fetchProfileDetailsAsync());
  await fetchFlagsAsync(flags, {
    source: 'web',
    userId: user?.id,
  })(dispatch);
};

type Props = {
  initApp: () => Promise<void>;
  children: ReactNode;
  notifications: Array<UINotification>;
};

const Home = (props: Props) => {
  const [isReady, setReady] = useState(false);
  useEffect(() => {
    props.initApp().finally(() => setReady(true));
  }, []);
  return (
    <>
      {isReady ? props.children : <PageLoader />}
      <Notifications
        hideNotification={hideNotification}
        removeNotification={removeNotification}
        notifications={props.notifications}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  notifications: state.toasts,
});

const mapDispatchToProps = {
  initApp,
};

// @ts-expect-error notifications is not properly typed
export default connect(mapStateToProps, mapDispatchToProps)(Home);
